import { fetchFromApi } from "react-redux-api-tools";
import { config } from "../../Constants";

export const fetchSubjects = () => (dispatch, getState) => {
  const requestData = {
    method: "GET",
  };

  dispatch({
    types: {
      request: "FETCH_SUBJECTS_REQUEST",
      success: "FETCH_SUBJECTS_SUCCESS",
      failure: "FETCH_SUBJECTS_FAILURE",
    },

    apiCallFunction: () =>
      fetchFromApi(config.API_URL + "/api/subject/", requestData),
  });
};

export const fetchSubjectsMultiSelect = () => (dispatch, getState) => {
  const requestData = {
    method: "GET",
  };

  dispatch({
    types: {
      request: "FETCH_SUBJECTS_REQUEST",
      success: "FETCH_SUBJECTS_SUCCESS",
      failure: "FETCH_SUBJECTS_FAILURE",
    },

    apiCallFunction: () =>
      fetchFromApi(config.API_URL + "/api/subject/", requestData),
  });
};

export const fetchSubjectsByQualification = (qualification) => (
  dispatch,
  getState
) => {
  const requestData = {
    method: "GET",
  };

  dispatch({
    types: {
      request: "FETCH_SUBJECTS_REQUEST",
      success: "FETCH_SUBJECTS_SUCCESS",
      failure: "FETCH_SUBJECTS_FAILURE",
    },

    apiCallFunction: () =>
      fetchFromApi(
        config.API_URL + `/api/subject/q/${qualification}/`,
        requestData
      ),
  });
};

export const fetchQualifications = () => (dispatch, getState) => {
  const requestData = {
    method: "GET",
  };

  dispatch({
    types: {
      request: "FETCH_QUALIFICATIONS_REQUEST",
      success: "FETCH_QUALIFICATIONS_SUCCESS",
      failure: "FETCH_QUALIFICATIONS_FAILURE",
    },

    apiCallFunction: () =>
      fetchFromApi(config.API_URL + "/api/qualification/", requestData),
  });
};
